export const USER_CONNECTED = 'user:connected';
export const USER_CONNECTED_HEADER_REFRESHED = 'user:connected-header-refreshed';
